<template>
  <div class="container" v-if="initialized">
    <div
      id="mask"
      v-if="popupState==='SHOW'||popupState==='MOBILE'||popupState==='EMAIL'||popupState==='NOTSAVED'"
      @click="popupState=''"
    ></div>
    <transition name="err">
      <div class="popup" v-if="popupState==='SHOW'">
        <div class="row">
          <div class="col-12">
            <button @click="popupState=''" class="closebtn">X</button>
            <img v-bind:src="currentImgUrl" @click="popupState=''" />
          </div>
        </div>
      </div>
    </transition>
    <transition name="err">
      <div class="popup" @click="popupState=''" v-if="popupState==='MOBILE'">
        <button @click="popupState=''" class="closebtn">X</button>
        <div class="row">
          <div class="col-12">
            <h1 style="text-align: left">{{ $t("result.transition.caption-mobile") }}</h1>
            <p>{{ $t("result.transition.mobile-p1") }}</p>
            <p>{{ $t("result.transition.mobile-p2") }}</p>
          </div>
        </div>
        <div class="row" style="height: 220px">
          <div class="col-12">
            <img :src="qrUrl" class="qrcode" />
          </div>
        </div>
      </div>
    </transition>
    <transition name="err">
      <div class="popup" v-if="popupState==='EMAIL'">
        <div class="row" v-if="sended===0">
          <div class="col-12">
            <button @click="popupState=''" class="closebtn">X</button>
            <br />
            <h1 style="text-align: left">{{ $t("result.transition.caption-email") }}</h1>
            <br />
          </div>
          <div class="col-12 form-group">
            <label for="email">{{ $t("register.email") }}:</label>
            <transition name="err">
              <span
                v-if="validationState==='ERROR' && !$v.email.required"
                class="error pushleft"
              >{{ $t("register.error.email_required") }}</span>
            </transition>
            <transition name="err">
              <span
                v-if="validationState==='ERROR' && !$v.email.email"
                class="error pushleft"
              >{{ $t("register.error.email_invalid") }}</span>
            </transition>
            <input
              id="email"
              type="email"
              class="form-control"
              v-model="mail"
              ref="setmail"
              @keydown="validationState=''"
            />
            <br />
          </div>
          <div class="col-12 right send-button-container">
            <button
              class="btn btn-primary"
              @click="send"
              :disabled="sendState==='SENDING'"
            >{{ $t("result.send") }}</button>
          </div>
        </div>
        <div class="row" v-if="sended===1||sended===-1">
          <div class="col-12" v-if="sended===1">
            <button @click="popupState=''" class="closebtn">X</button>
            <br />
            <h1 style="text-align: left">{{ $t("result.sended") }}</h1>
            <p>{{ $t("result.sendedP1") }}</p>
          </div>
          <div class="col-12" v-if="sended===-1">
            <button @click="popupState=''" class="closebtn">X</button>
            <br />
            <h1 style="text-align: left">{{ $t("result.sendedFailed") }}</h1>
            <p>{{ $t("result.sendedFailedP1") }}</p>
          </div>
          <div class="col-12 right send-button-container">
            <button class="btn btn-primary" @click="popupState='';sended=0">{{ $t("result.ok") }}</button>
          </div>
        </div>
      </div>
    </transition>
    <transition name="err">
      <div class="popup" v-if="popupState==='NOTSAVED'">
        <div class="row">
          <div class="col-12">
            <h1>{{ $t("result.transition.captionNotSaved") }}</h1>
            <br />
            <p v-html="$t('result.transition.notSavedP1')"></p>
            <p v-html="$t('result.transition.notSavedP2')"></p>
            <br />
            <hr />
          </div>
          <div class="col-6">
            <button
              class="btn btn-secondary"
              @click="isSaved=true;popupState='';reset()"
            >{{ $t("result.transition.button_2") }}</button>
          </div>
          <div class="col-6 right">
            <button
              class="btn btn-secondary"
              @click="popupState=''"
            >{{ $t("result.transition.button_1") }}</button>
          </div>
        </div>
      </div>
    </transition>

    <div class="row vertical-center">
      <div class="col-12">
        <h1>{{ $t("result.caption") }}</h1>
        <p>{{ $t("result.p1") }}</p>
        <br />
        <div class="row">
          <div class="col-7">
            <img id="wordcloud" :src="wclink" alt="Word Cloud" />
          </div>
          <div class="col-5">
            <img id="box" src="../assets/mme-schachtel.png" />
          </div>
        </div>
        <div class="row space-top">
          <div class="col-12"></div>
        </div>
        <div class="row">
          <div class="col-4 center">
            <a :href="downloadlink()" class="btn btn-light btn-transition" @click="isSaved=true">
              <span class="icodownload"></span>
            </a>
            <br />
            <span class="expl" v-html="$t('result.transition.download')"></span>
          </div>
          <div class="col-4 center">
            <button class="btn btn-light btn-transition" @click="mobile">
              <span class="icomobile"></span>
            </button>
            <br />
            <span class="expl" v-html="$t('result.transition.mobile')"></span>
          </div>
          <div class="col-4 center">
            <button class="btn btn-light btn-transition" @click="email">
              <span class="icoemail"></span>
            </button>
            <br />
            <span class="expl" v-html="$t('result.transition.email')"></span>
          </div>
        </div>
        <div class="row">
          <div class="col-12 right">
            <button class="btn btn-light btn-transition" @click="reset">
              <span class="icoreset"></span>
            </button>
            <span class="expl" v-html="$t('result.transition.reset')"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode"
import participant from "../modules/Participant"
import adjectives from "../modules/Adjectives"
import simulation from "../modules/Simulation"

export default {
  name: "Result",
  data() {
    return {
      initialized: false,
      isSaved: false,
      sended: 0,
      popupState: "",
      currentImgUrl: "",
      showTransition: false,
      validationState: null,
      qrUrl: null,
      mail: null,
      e: participant.e,
      s: participant.s,
      n: participant.n,
      t: participant.t,
      f: participant.f,
      j: participant.j,
      wclink:
        "https://missionfuture.swiss-skills.ch/mfp/java/service/wordcloud/create?e=" +
        participant.e +
        "&s=" +
        participant.s +
        "&n=" +
        participant.n +
        "&t=" +
        participant.t +
        "&f=" +
        participant.f +
        "&j=" +
        participant.j +
        "&lang=" +
        this.$i18n.locale +
        "&size=m&shape=rect&cm=green",
      imglinks: adjectives.links,
      sendState: "",
    }
  },
  methods: {
    showImg(name) {
      this.currentImgUrl =
        "https://missionfuture.swiss-skills.ch/mfp/java/service/adjectives/img?a=" +
        name +
        "&lang=de"
      this.popupState = "SHOW"
    },
    mobile() {
      QRCode.toDataURL(
        "https://missionfuture.swiss-skills.ch/mfp/java/service/result/wordcloud?e=" +
          participant.e +
          "&s=" +
          participant.s +
          "&n=" +
          participant.n +
          "&t=" +
          participant.t +
          "&f=" +
          participant.f +
          "&j=" +
          participant.j +
          "&lang=" +
          this.$i18n.locale +
          "&firstname=" +
          participant.firstname +
          "&lastname=" +
          participant.lastname
      ).then((url) => {
        this.qrUrl = url
        this.popupState = "MOBILE"
        this.isSaved = true
        window.scrollTo(0, 1)
      })
    },
    email() {
      this.mail = participant.email
      this.popupState = "EMAIL"
      window.scrollTo(0, 1)
      setTimeout(() => {
        this.$refs.setmail.focus()
      }, 500)
    },
    send() {
      document.body.style.cursor = "wait"
      this.sendState = "SENDING"
      let url =
        "https://missionfuture.swiss-skills.ch/mfp/java/service/result/send?e=" +
        participant.e +
        "&s=" +
        participant.s +
        "&n=" +
        participant.n +
        "&t=" +
        participant.t +
        "&f=" +
        participant.f +
        "&j=" +
        participant.j +
        "&lang=" +
        this.$i18n.locale +
        "&firstname=" +
        participant.firstname +
        "&lastname=" +
        participant.lastname +
        "&recipient=" +
        this.mail
      this.$http.get(url).then((response) => {
        document.body.style.cursor = "default"
        this.sendState = ""
        if (response.status === 200) {
          this.sended = 1
          this.isSaved = true
        } else {
          this.sended = -1
        }
      })
    },
    downloadlink() {
      return (
        "https://missionfuture.swiss-skills.ch/mfp/java/service/result/wordcloud?direct=true&e=" +
        participant.e +
        "&s=" +
        participant.s +
        "&n=" +
        participant.n +
        "&t=" +
        participant.t +
        "&f=" +
        participant.f +
        "&j=" +
        participant.j +
        "&lang=" +
        this.$i18n.locale +
        "&firstname=" +
        participant.firstname +
        "&lastname=" +
        participant.lastname
      )
    },
    reset() {
      if (this.isSaved === false) {
        this.popupState = "NOTSAVED"
      } else {
        participant.tan = null
        delete participant.result
        delete participant.e
        delete participant.s
        delete participant.n
        delete participant.t
        delete participant.f
        delete participant.j
        delete participant.firstname
        delete participant.lastname
        delete participant.phone
        delete participant.email
        delete participant.age
        delete participant.postcode
        delete participant.sex
        delete participant.language
        if (simulation.mode === "staging") {
          this.$router.push({ path: "/", params: { simulate: true } })
        } else {
          this.$router.push("/")
        }
      }
    },
  },
  created() {
    if (participant.tan === null) {
      this.$router.push("/tan")
    }
  },
  mounted() {
    this.initialized = true
  },
}
</script>

<style scoped>
#wordcloud {
  width: 100%;
  height: auto;
}
.container {
  max-width: 600px !important;
}

.popup .btn-secondary {
  font-size: 15px !important;
  border-radius: 10px !important;
  min-width: 220px !important;
  height: 100px !important;
}

#mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: black;
  opacity: 0.5;
  z-index: 1;
}

#box {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  height: auto;
  padding-left: 40px;
  padding-right: 40px;
}
h1 {
  background-color: #e5efef;
  padding: 10px;
  color: #006265;
  text-align: center;
}

.imgcard {
  width: 100%;
  height: auto;
  display: inline-flex;
  position: absolute;
  padding: 1px;
  margin: -1px;
  cursor: pointer;
}

.colcontainer {
  height: 50%;
}

.popup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #e5efef;
  padding: 30px;
  border-radius: 30px;
  border: 1px solid #ccc;
  max-width: 800px;
  z-index: 2;
}

.popup h1 {
  margin-bottom: 25px;
}

.closebtn {
  position: absolute;
  top: -16px;
  right: 0px;
  border-radius: 50%;
  height: 35px;
  width: 35px;
  border: 1px solid gray;
  background-color: white;
  color: gray;
  font-weight: bold;
  outline: none;
}

.space-top {
  margin-top: 60px;
}

.btn-transition {
  height: 110px;
  width: 110px;
  border-radius: 20px !important;
}

.icodownload::after {
  height: 80px;
  width: auto;
  content: url("../assets/druck80.png");
}

.icoemail::after {
  height: 80px;
  width: auto;
  content: url("../assets/sms80.png");
}

.icomobile::after {
  height: 80px;
  width: auto;
  content: url("../assets/handy80.png");
}

.icoreset::after {
  height: 80px;
  width: auto;
  content: url("../assets/web_button80.png");
}

.expl {
  font-weight: bold;
  color: #006266;
  height: 100%;
  font-size: 120%;
  align-items: center;
}

.hidden {
  visibility: hidden;
}

.qrcode {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.err-enter,
.err-leave-to {
  visibility: hidden;
  opacity: 0;
}
.err-enter-active,
.err-leave-active {
  transition: all, 0.5s;
}

.send-button-container .btn {
  border-radius: 50% !important;
  height: 100px !important;
  width: 100px !important;
  font-size: 0px !important;
}

.send-button-container .btn-primary {
  border-color: white !important;
  background-color: white !important;
  max-width: 100px;
  max-height: 100px;
  background-image: url("../assets/web_button.png");
  background-repeat: no-repeat;
  background-size: cover;
}

@media screen and (max-width: 770px) {
  .popup {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    background-color: #e5efef;
    padding: 10px;
    border-radius: 30px;
    border: 1px solid #ccc;
    width: 95%;
    max-width: 800px;
    z-index: 2;
  }
  .btn-transition {
    height: 50px !important;
    width: 50px !important;
    border-radius: 20px !important;
  }
  .expl {
    font-size: 100% !important;
  }

  .icodownload {
    height: 25px;
    width: auto;
  }

  .icoemail {
    height: 25px;
    width: auto;
  }

  .icomobile {
    height: 25px;
    width: auto;
  }

  .icoreset {
    height: 25px;
    width: auto;
  }
}
@media screen and (max-width: 770px) and (orientation: landscape) {
  .btn-primary {
    border-color: white !important;
    background-color: white !important;
    max-width: 65px;
    max-height: 65px;
    background-image: url("../assets/web_button.png");
    background-repeat: no-repeat;
    background-size: cover;
  }

  .btn {
    height: 65px !important;
    width: 65px !important;
    font-size: 0px !important;
  }
}
@media screen and (max-width: 770px) and (orientation: portrait) {
  .btn-primary {
    border-color: white !important;
    background-color: white !important;
    max-width: 65px;
    max-height: 65px;
    background-image: url("../assets/web_button.png");
    background-repeat: no-repeat;
    background-size: cover;
  }

  .btn {
    height: 65px !important;
    width: 65px !important;
    font-size: 0px !important;
  }
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .popup {
    min-width: 600px;
  }
}
</style>